import { useBreakpointValue } from '@genial/utils';

import { CardItemDesktop } from './desktop';
import { CardItemMobile } from './mobile';

export const CardItem = (props) => {
  const responsiveCardItem = useBreakpointValue({
    base: <CardItemMobile {...props} />,
    sm: <CardItemDesktop {...props} />,
  });

  return responsiveCardItem;
};
